<template>
  <div class="z-border-red pa-2 mb-2" style="position: relative" v-if="stock">
    <v-btn
      fab
      depressed
      @click="$emit('onDelete')"
      small
      class="extra-small"
      color="primary"
      style="position: absolute; top: 0; right: 0; margin-top: -15px; margin-right: -15px"
    >
      <i class="fa fa-trash middle"></i>
    </v-btn>

    <v-layout wrap>
      <v-flex xs12 sm1>
        <move-vertical slot="move" :index="index" :max="max" @onMove="onMove"></move-vertical>
      </v-flex>
      <v-flex xs12 sm2 md1 class="form-control pa-2 text-center">
        <div style="width: 50px ; position: relative;" class="ma-auto">
          <i
            v-if="stock[7]"
            class="fa fa-trash middle primary-color"
            style="position: absolute; right: -15px; cursor: pointer; z-index: 2;"
            @click="deletePhoto"
          ></i>
          <uploadfile :height="50" v-model="stock[7]" data-vv-as="Stock Image">
            <v-btn flat fab small><v-icon small>camera_alt</v-icon></v-btn>
          </uploadfile>
        </div>
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'option_' + index"
          :data-vv-name="'option_' + index"
          :data-vv-as="$t('option')"
          v-validate="`required|excluded:${excludestockname}`"
          class="form-control"
          :id="'optionInput' + index"
          :placeholder="$t('option') + ' ' + $t('EX.Size, Color, Weight')"
          v-model="stock[1]"
          @blur="$set(stock, 1, noSpaceAndSpecial($event))"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'sku_' + index"
          :data-vv-name="'sku_' + index"
          :data-vv-as="
            $t('SKU') +
              (selectedBot.sokochan_info && selectedBot.sokochan_info.status ? '' : ' (Optional)')
          "
          class="form-control"
          v-validate="
            selectedBot.sokochan_info && selectedBot.sokochan_info.status ? 'required' : ''
          "
          :id="'skuInput' + index"
          :placeholder="
            $t('SKU') +
              (selectedBot.sokochan_info && selectedBot.sokochan_info.status ? '' : ' (Optional)')
          "
          v-model="stock[5]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="number"
          :name="'weight' + index"
          :data-vv-name="'weight' + index"
          :data-vv-as="$t('weight') + ' (Optional)'"
          class="form-control"
          :id="'weightInput' + index"
          :placeholder="$t('weight') + ' (Optional)'"
          v-model="stock[8]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2"></v-flex>
      <v-flex xs12 offset-sm2 sm2 offset-md2 class="form-control pa-2">
        <input
          type="number"
          :name="'quantity_' + index"
          :data-vv-name="'quantity_' + index"
          :data-vv-as="$t('quantity')"
          v-validate="'required|numeric'"
          maxlength="4"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          :id="'quantityInput' + index"
          :placeholder="$t('quantity')"
          v-model="stock[2]"
          :disabled="
            selectedBot.packhai_status == true &&
              selectedBot.packhai_token &&
              product.ref_code &&
              product.ref_code.includes('PACKHAI')
          "
          @blur="$set(stock, 2, numberOnly($event))"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2" v-if="enableProductCost">
        <input
          type="number"
          :name="'cost_' + index"
          :data-vv-name="'cost_' + index"
          :data-vv-as="$t('product_cost')"
          v-validate="'decimal:2|min_value:1'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          :id="'costInput' + index"
          :placeholder="$t('product_cost') + ' (Optional)'"
          v-model="stock[9]"
          @blur="$set(stock, 9, decimalOnly($event))"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="number"
          :name="'price_' + index"
          :data-vv-name="'price_' + index"
          :data-vv-as="$t('Price')"
          v-validate="'decimal:2|min_value:1'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          :id="'priceInput' + index"
          :placeholder="$t('Price') + ' (Optional)'"
          v-model="stock[3]"
          @blur="
            $set(stock, 3, decimalOnly($event))
            onBlurPrice($event)
          "
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="number"
          :name="'saleprice_' + index"
          :data-vv-name="'saleprice_' + index"
          :data-vv-as="$t('Sale price')"
          v-validate="'decimal:2|min_value:1|isLessThanOrEqual:' + stock[3]"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          :id="'salepriceInput' + index"
          :placeholder="$t('Sale price') + ' (Optional)'"
          v-model="stock[4]"
          @blur="$set(stock, 4, decimalOnly($event))"
        />
      </v-flex>
      <v-flex xs12>
        <div
          class="form-control"
          :class="{
            'has-error':
              errors.has('option_' + index) ||
              errors.has('quantity_' + index) ||
              errors.has('cost_' + index) ||
              errors.has('price_' + index) ||
              errors.has('saleprice_' + index) ||
              errors.has('sku_' + index)
          }"
        >
          <span class="text-error" v-show="errors.has('option_' + index)">{{
            errors.first('option_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('quantity_' + index)">{{
            errors.first('quantity_' + index)
          }}</span>
          <span class="text-error" v-if="enableProductCost" v-show="errors.has('cost_' + index)">{{
            errors.first('cost_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('price_' + index)">{{
            errors.first('price_' + index)
          }}</span>
          <span class="text-error" v-show="errors.has('saleprice_' + index)">{{
            $t('Sale Price cannot be more than Normal Price and less than zero')
          }}</span>
          <span class="text-error" v-show="errors.has('sku_' + index)">{{
            errors.first('sku_' + index)
          }}</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MoveVertical from '@/components/elements/MoveVertical'
import uploadfile from '@/components/elements/uploadfile'
export default {
  inject: ['$validator'],
  props: ['value', 'index', 'max', 'productstock', 'stockkey', 'product', 'enableProductCost'],
  data: function() {
    return {
      stock: null
    }
  },
  components: {
    MoveVertical,
    uploadfile
  },
  mounted() {
    this.stock = this.value
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    // stock() {
    //   return this.value
    // },
    excludestockname() {
      try {
        return this.productstock.filter((el, index) => index != this.stockkey).map(v => v[1])
      } catch (error) {
        return ''
      }
    }
  },
  methods: {
    deletePhoto() {
      this.$set(this.stock, 7, null)
    },
    onMove: function(payload) {
      this.$emit('onMove', payload)
    },
    onBlurPrice: function() {
      this.$set(this.stock, 4, this.stock[3])
    }
  },
  watch: {
    value: function(newVal) {
      this.stock = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStockItem.vue